import { GlobalHelpers } from '../mainExports'
import { i18n } from '@leapsight/portal'
import { LatLng } from '@/helpers/objects'
import ThingsHelpers from '@/helpers/things/thingsHelpers'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import tz from 'dayjs/plugin/timezone'

import {
  NOTIFICATION_FIND_URI,
  NOTIFICATION_LIMIT_PAGINATION,
  NOTIFICATION_STATE_URI,
  connectionService,
  RACE_TIMEOUT
} from '@leapsight/styleguide'
import store from '@/store'
export default {
  getConditions(element) {
    const conditionsIds = Object.keys(element.data.agent.conditions)
    const conditions = conditionsIds.map(conditionId => {
      const data = element.data.agent.conditions[conditionId]

      switch (conditionId) {
        case 'mrn:agent_condition:geofence':
          const name =
            data.type == 'in'
              ? i18n.t(
                  'live_tracking.map.notifications.data_table.labels.condition_geofence_type_in'
                )
              : i18n.t(
                  'live_tracking.map.notifications.data_table.labels.condition_geofence_type_out'
                )

          // hay config de eventos viejas fuera de zona en dónde las zonas vienen 
          // por ej así YCKiVTkwROPPFDXCS51AIg==
          const geofenceValues = Object.values(data.geofences || {}).join(", ")
          const geofenceName =
            geofenceValues.includes("==")
              ? "zonas configuradas"
              : data.geofences?.data?.properties?.name || geofenceValues
          const geofenceData = data?.geofences?.data
          const conditionGeoFence = {
            id: conditionId,
            name,
            geofenceData,
            geofenceName,
            data: data
          }
          return conditionGeoFence
        case 'mrn:agent_condition:speed_limit':
          const conditionSpeed = {
            id: conditionId,
            name: i18n.t(
              'live_tracking.map.notifications.data_table.labels.condition_speed_limit'
            ),
            speedLimit: data.speed_limit
          }
          return conditionSpeed
        case 'mrn:agent_condition:low_battery':
          const conditionLowBattery = {
            id: conditionId,
            name: i18n.t(
              'live_tracking.map.notifications.data_table.labels.condition_low_battery'
            ),
            lowLevel: data.low_level
          }
          return conditionLowBattery
        case 'mrn:agent_condition:no_report':
          const conditionNoReport = {
            id: conditionId,
            name: 'No Reporta',
            noReport: data
          }
          return conditionNoReport
        case 'mrn:agent_condition:main_power':
          const conditionMainPower = {
            id: conditionId,
            name: 'Main Power',
            mainPower: data
          }
          return conditionMainPower

        case 'mrn:agent_condition:ignition':
          const conditionIgnition = {
            id: conditionId,
            name,
            contactOn: data
          }
          return conditionIgnition
        case 'mrn:agent_condition:detention':
          const conditionDetention = {
            id: conditionId,
            name: 'Detencion Prolongada',
            speed_threshold: data
          }
          return conditionDetention

        case 'mrn:agent_condition:fuel_consumption_deviation':
          const conditionFuelDeviation = {
            id: conditionId,
            name: 'Desvio configurado',
            fuelDeviation: data.fuel_deviation
          }
          return conditionFuelDeviation

        case 'mrn:agent_condition:ralenti':
          const conditionRalenti = {
            id: conditionId,
            name: 'Velocidad máxima',
            name1: 'RPM máximo',
            rpmLimit: data.rpm_limit,
            minSpeed: data.min_speed
          }
          return conditionRalenti

        case 'mrn:agent_condition:fuel_charge':
          const conditionFuelCharge = {
            id: conditionId,
            name: 'Carga configurada',
            fuelLimit: data.fuel_limit
          }
          return conditionFuelCharge

        case 'mrn:agent_condition:movement_start':
          const conditionMovStart = {
            id: conditionId,
            name: 'Inicio de movimiento'
          }
          return conditionMovStart

        case 'mrn:agent_condition:temperature':
          const conditionTemperature = {
            id: conditionId,
            name: 'Temperatura mínima',
            name1: 'Temperatura máxima',
            minTemp: data.min_temp,
            maxTemp: data.max_temp
          }
          return conditionTemperature

        case 'mrn:agent_condition:engine_temperature':
          const conditionEngineTemperature = {
            id: conditionId,
            name: 'Temperatura máxima',
            maxTemp: data.max_temp
          }
          return conditionEngineTemperature

        case 'mrn:agent_condition:excessive_rpm':
          const conditionRpmExcessive = {
            id: conditionId,
            name: 'RPM máximo',
            rpmLimit: data.rpm_limit,
          }
          return conditionRpmExcessive

        case 'mrn:agent_condition:generic_hard_brake':
          const conditionGenericHardBrake = {
            id: conditionId,
            data: data
          }
          return conditionGenericHardBrake

        case 'mrn:agent_condition:generic_hard_acceleration' :
          const conditionGenericHardAcceleration = {
            id: conditionId,
            data: data
          }
          return conditionGenericHardAcceleration

        case 'mrn:agent_condition:generic_sharped_turn' :
          const conditionGenericSharpedTurn = {
            id: conditionId,
            data: data
          }
          return conditionGenericSharpedTurn

        case 'mrn:agent_condition:generic_unauthorized_stop' :
          const conditionGenericUnauthorizedStop = {
            id: conditionId,
            data: data
          }
          return conditionGenericUnauthorizedStop

        case 'mrn:agent_condition:generic_put_into_service' :
          const conditionGenericPutIntoService = {
            id: conditionId,
            data: data
          }
          return conditionGenericPutIntoService

        case 'mrn:agent_condition:generic_taken_out_of_service' :
          const conditionGenericTakenOutOfService = {
            id: conditionId,
            data: data
          }
          return conditionGenericTakenOutOfService

        case 'mrn:agent_condition:generic_still_detached' :
          const conditionGenericSillDetached = {
            id: conditionId,
            data: data
          }
          return conditionGenericSillDetached

        case 'mrn:agent_condition:generic_event_test' :
          const conditionGenericEventTest = {
            id: conditionId,
            data: data
          }
          return conditionGenericEventTest

        case 'mrn:agent_condition:generic_seat_passenger' :
          const conditionGenericSeatPassenger = {
            id: conditionId,
            data: data
          }
          return conditionGenericSeatPassenger

        case 'mrn:agent_condition:generic_delivery' :
          const conditionGenericDelivery = {
            id: conditionId,
            data: data
          }
          return conditionGenericDelivery
        default:
          const conditionDefaut = {
            id: 'test'
          }
          return conditionDefaut
      }
    })
    return conditions
  },
  functionRace(from, to, page, partialNotifications = []) {
    return new Promise((resolve, reject) => {
      const notifications = partialNotifications
      const connection = GlobalHelpers.getConnection()
      const url = NOTIFICATION_FIND_URI
      const args = []
      const security = connectionService.createkwArgs()
      const kwArgs = {
        ...security,
        query_spec: {
          _sort: 'notif_timestamp desc',
          _limit: 500,
          _from: from,
          _to: to
        }
      }
      if (page) {
        kwArgs.query_spec['_page'] = page
        kwArgs.query_spec['_limit'] = NOTIFICATION_LIMIT_PAGINATION
      }
      connection.session.call(url, args, kwArgs, {}).then(
        res => {
          res.map(item => {
            notifications.push(item)
          })

          resolve(notifications)
        },
        wampError => {
          reject(wampError)
        }
      )
    })
  },

  getNotifications(page, fromQuery, fromTimeQuery, toQuery, toTimeQuery) {
    return new Promise((resolve, reject) => {
      const p1 = GlobalHelpers.customTimer({ ms: RACE_TIMEOUT })
      //PARAMS
      dayjs.extend(utc)
      dayjs.extend(tz)

      const from = fromQuery
        ? dayjs(fromQuery + fromTimeQuery)
            .utcOffset('0')
            .valueOf()
        : dayjs()
            .utcOffset('0')
            .subtract(89, 'day')
            .valueOf()
      const to = toQuery
        ? dayjs(toQuery + toTimeQuery)
            .utcOffset('0')
            .valueOf()
        : dayjs()
            .utcOffset('0')
            .valueOf()

      // Se utiliza functionRace para evitar en la recursión llamar al Promise.race n veces
      const p2 = this.functionRace(from, to, page)

      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getErrorMessage(errorCode) {
    let msje = ''
    switch (errorCode) {
      case 'com.magenta.error.no_data_found':
        msje = i18n.t(
          'live_tracking.map.notifications.data_table.errors.no_data_found'
        )
        break
      case 'com.magenta.error.missing_required_parameters':
        msje = i18n.t(
          'live_tracking.map.notifications.data_table.errors.missing_required_parameters'
        )
        break
      case 'timeout':
        msje = i18n.t('general.snackbarComponent.errors.timeout')
        break
    }
    return msje
  },
  /**
   *
   * @param param0
   * @param payload Array de notificaciones a marcar como leidas
   * @returns Notificación con estado leida para marcar la misma como tal en la data table
   */
  markNotificationAsRead(payload) {
    return new Promise((resolve, reject) => {
      const args = payload.map(item => {
        return {
          id: item.id,
          read: 'true',
          notif_timestamp: item.notifTimestamp
        }
      })
      const kwArgs = connectionService.createkwArgs()
      const connection = GlobalHelpers.getConnection()
      connection.session
        .call(NOTIFICATION_STATE_URI, args, kwArgs, {})
        .then(response => {
          //el timeout da margen a que el backend actualice el valor real de las notificaciones que marcamos como leidas, principalmente cuando son muchas
          setTimeout(() => {
            store.dispatch('notificationsState/setUnreadNotifications')
          }, 1000)
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  getUnreadNotifications() {
    return new Promise((resolve, reject) => {
      const p1 = GlobalHelpers.customTimer({ ms: RACE_TIMEOUT })
      //PARAMS
      const from = dayjs()
        .subtract(3, 'week')
        .valueOf()
      const to = dayjs().valueOf()
      const p2 = this._getUnreadNotificationsCount(from, to)

      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  _getUnreadNotificationsCount(from, to) {
    return new Promise((resolve, reject) => {
      const connection = GlobalHelpers.getConnection()
      const url = 'com.magenta.notification.unread_count'
      const args = []
      const security = connectionService.createkwArgs()
      const kwArgs = {
        ...security,
        query_spec: {
          _from: from,
          _to: to
        }
      }
      connection.session.call(url, args, kwArgs, {}).then(
        res => {
          resolve(res)
        },
        wampError => {
          reject(wampError)
        }
      )
    })
  },
  deleteNotifications(payload) {
    return new Promise((resolve, reject) => {
      const args = payload.map(item => {
        return {
          id: item.id,
          deleted: 'true',
          notif_timestamp: item.notifTimestamp
        }
      })
      const kwArgs = connectionService.createkwArgs()
      const connection = GlobalHelpers.getConnection()
      connection.session
        .call(NOTIFICATION_STATE_URI, args, kwArgs, {})
        .then(response => {
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  getMarkerInfo(item, showEntityType) {
    const obj = {}

    obj.position = new LatLng({
      lat: item.data.signal.coordinates[0],
      lng: item.data.signal.coordinates[1]
    })

    obj.heading = ThingsHelpers.getThingHeading(item.data.signal.heading)

    //********************************************************************************************************************************/
    //** TODO => obtener el type y subtype de la notificacion para poder representar el icono cuando "showEntityType" esta en "True" */
    //********************************************************************************************************************************/

    const markerInfo = {
      status: 'events',
      heading: obj.heading,
      type: item.data.signal.type ?? 'vehicle',
      subType: item.data.signal.subType ?? 'car',
      follow: false
    }
    obj.icon = ThingsHelpers.getThingIcon(markerInfo, showEntityType, true)

    return obj
  },
  showNotificationMarker(map, notificationMarker, marker) {
    if (notificationMarker !== '') {
      notificationMarker.setMap(null)
    }
    const lat = marker.position.lat
    const lng = marker.position.lng
    const myLatLng = new google.maps.LatLng(lat, lng)
    const image = {
      url: marker.icon,
      size: new google.maps.Size(64, 64),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(32, 32)
    }

    const googleMarker = new google.maps.Marker({
      position: myLatLng,
      map: map,
      icon: image,
      zIndex: 500
    })

    return googleMarker
  }
}
